import { Close, InfoOutlined } from '@mui/icons-material';
import { Box, CSSObject, IconButton, Typography } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';
import { SystemMessageTypeEnum } from 'src/shared/models/enums/systemMessageType.enum';
import dayjs from 'dayjs';
import { SystemMessage } from 'src/shared/models/gui/systemMessage';
import { Colors } from '../styles/colors';

export const isSystemMessageExpired = (sysMess: SystemMessage) => {
  const hasExpireDate = sysMess && sysMess.messageExpireDate && dayjs(sysMess.messageExpireDate).isValid();
  const isExpired = hasExpireDate && dayjs(sysMess.messageExpireDate).isBefore(dayjs(new Date()));
  return sysMess && !isExpired;
};

export const SystemMessageContainer = () => {
  const { systemMessage, setSystemMessage } = useGlobals();

  const styling: CSSObject =
    systemMessage?.type === SystemMessageTypeEnum.UserMessage
      ? {
          backgroundColor: Colors.MenuIcon,
          color: '#fff',
        }
      : {
          backgroundColor: Colors.Orange.Main,
          color: '#fff',
        };

  return systemMessage ? (
    <Box
      sx={{
        ...styling,
        height: systemMessage.height,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1,
        overflowX: 'auto',
      }}
    >
      <Typography sx={{ lineHeight: 1, mr: systemMessage.hideable ? 5 : 0, display: 'flex', alignItems: 'center' }}>
        <InfoOutlined sx={{ color: '#fff', mr: 1 }} />
        <>{systemMessage.message}</>
      </Typography>
      {systemMessage.hideable && (
        <IconButton sx={{ color: '#fff', position: 'absolute', top: 0, right: 0 }} onClick={() => setSystemMessage(undefined)} size='large'>
          <Close />
        </IconButton>
      )}
    </Box>
  ) : null;
};
